import styled from "styled-components";

import { Menu } from "@material-ui/core";

export const Container = styled(Menu)`
  > * {
    .selected {
      background-color: ${(props) => props.theme.colors.secondary} !important;
      color: white !important;
    }
  }
`;
